import { ref, Ref } from "vue"
import { UserInfo } from "@/services/AuthService.interface"

const loggedInUser: Ref<UserInfo | null> = ref(null)

export default loggedInUser
